<script>
	import { getContext } from 'svelte';

	const { width, height, xScale, yScale } = getContext('LayerCake');

	export let gridlines = true;
	export let formatTick = (d, i) => d;
	export let baseline = false;
	export let snapTicks = false;
	export let ticks = undefined;
	export let tickNumber = undefined;
	export let fill = "#000";
	export let stroke = "#000";
	export let defaultAnchor = "middle";

	$: tickVals = Array.isArray(ticks) ? ticks : $xScale.ticks(tickNumber);

	function textAnchor(i) {
		if (snapTicks === true) {
			if (i === 0) {
				return 'start';
			}
			if (i === tickVals.length - 1) {
				return 'end';
			}
		}
		return defaultAnchor;
	}
</script>

<g class='axis x-axis' style="--fill: {fill}">
	{#each tickVals as tick, i}
		<g class='tick tick-{ tick }' transform='translate({$xScale(tick)},{$yScale.range()[0]})'>
			{#if gridlines !== false}
				<line stroke="{stroke}" y1='-5' y2='0' x1='0' x2='0'></line>
			{/if}
			<text y='16' text-anchor='{textAnchor(i)}'>{formatTick(tick, i)}</text>
		</g>
	{/each}
	{#if baseline === true}
		<line class="baseline" y1='{$height + 0.5}' y2='{$height + 0.5}' x1='0' x2='{$width}'></line>
	{/if}
</g>

<style>
	.tick {
		font-size: .725em;
		font-weight: 200;
	}

	/* line,
	.tick line {
		stroke: var(--fill);
	} */

	.tick-1 line {
		stroke: #000;
	}

	.tick text {
		fill: var(--fill);
	}

	.baseline {
		stroke-dasharray: 0;
	}
</style>
